/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  BillingDiscount,
  BillingInterval,
  BillingInvoicePreview,
  BillingMeter,
  BillingMeterUsage,
  BillingPortal,
  BillingProduct,
  BillingSwitchAction,
  BillingUpgrade,
  MigrateOrganizationParameters,
  SitePageviews,
  UpgradeOrganizationBilling,
} from "./data-contracts";

/**
 * No description
 * @tags billing, internal
 * @name UpgradeOrganizationPlan
 * @summary Upgrade an organization billing plan
 * @request POST:/orgs/{organizationId}/billing
 * @secure
 */

// @ts-ignore
export const upgradeOrganizationPlan: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** The app screen URL to bring the user back to after a successful checkout. */
    successReturnURL?: string;
    /** The app screen URL to bring the user back to after a canceled checkout. */
    cancelReturnURL?: string;
  };
  RequestBody: UpgradeOrganizationBilling;
  RequestHeaders: {};
  ResponseBody: BillingUpgrade;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing",
  method: "post",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name MigrateOrganizationPlan
 * @summary Migrate an organization's legacy billing plan to new pricing
 * @request POST:/orgs/{organizationId}/billing/migrate
 * @secure
 */

// @ts-ignore
export const migrateOrganizationPlan: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: MigrateOrganizationParameters;
  RequestHeaders: {};
  ResponseBody:
    | {
        result: "success";
      }
    | {
        result: "checkout";
        sessionId: string;
      };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/migrate",
  method: "post",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name PreviewMigrateOrganizationPlan
 * @summary Preview a migration of an organization to new pricing
 * @request POST:/orgs/{organizationId}/billing/migrate/preview
 * @secure
 */

// @ts-ignore
export const previewMigrateOrganizationPlan: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: MigrateOrganizationParameters;
  RequestHeaders: {};
  ResponseBody: {
    totals: {
      /** Count of all members */
      members: number;
      /** Count of all premium sites */
      premiumSites: number;
      /** Count of all ultimate sites */
      ultimateSites: number;
    };
    invoice?: BillingInvoicePreview;
    discount?: BillingDiscount;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/migrate/preview",
  method: "post",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name ListSitesPageviews
 * @summary Returns a list of site identifiers paired with their pageviews in the last 30 days
 * @request GET:/orgs/{organizationId}/billing/migrate/sites
 * @secure
 */

// @ts-ignore
export const listSitesPageviews: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePageviews[];
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/migrate/sites",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name GetOrganizationBillingPortal
 * @summary Get the billing portal
 * @request GET:/orgs/{organizationId}/billing/portal
 * @secure
 */

// @ts-ignore
export const getOrganizationBillingPortal: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingPortal;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/portal",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Generates a billing invoice preview for organizations without an active subscription.
 * @tags billing, internal
 * @name PreviewBillingInvoice
 * @summary Preview billing invoice
 * @request GET:/orgs/{organizationId}/billing/preview
 * @secure
 */

// @ts-ignore
export const previewBillingInvoice: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** The desired billing interval plan */
    interval: BillingInterval;
    /** The desired core plan */
    product: BillingProduct;
    /** The desired amount of members in the organization */
    members?: number;
    /** The desired amount of published premium sites */
    premiumSites?: number;
    /** The desired amount of published ultimate sites */
    ultimateSites?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingInvoicePreview & {
    action: BillingSwitchAction | null;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/preview",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name EnableOrganizationBillingMeterAddon
 * @summary Enable billing meter addon for an organization
 * @request PUT:/orgs/{organizationId}/billing/meters/{meterName}
 * @secure
 */

// @ts-ignore
export const enableOrganizationBillingMeterAddon: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}",
  method: "put",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name DisableOrganizationBillingMeterAddon
 * @summary Disable billing meter addon for an organization
 * @request DELETE:/orgs/{organizationId}/billing/meters/{meterName}
 * @secure
 */

// @ts-ignore
export const disableOrganizationBillingMeterAddon: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}",
  method: "delete",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name GetOrganizationBillingMeterUsage
 * @summary Get billing meter usage for an organization
 * @request GET:/orgs/{organizationId}/billing/meters/{meterName}/usage
 * @secure
 */

// @ts-ignore
export const getOrganizationBillingMeterUsage: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingMeterUsage;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}/usage",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};
